'use strict';

const axios = require('axios');

module.exports = (bonusProducsData) => {
    return {
        namespaced: true,
        state: {
            ...bonusProducsData
        },
        getters: {},
        actions: {
            addBonusProductToBasket({ state, commit }, productId) {
                return axios({
                    method: 'post',
                    url: state.addNewURL,
                    data: { productId },
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then((result) => {
                    commit('setBonusProductData', result.data.bonusItems);
                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, { root: true });
                });
            }
        },
        mutations: {
            setBonusProductData(state, bonusProductsState) {
                Object.assign(state, bonusProductsState);
            }
        }
    };
};
